import { FC } from 'react'
import styles from './SectionBottomBorderTitle.module.scss'

interface Props {
  text: string
  subTextElement?: JSX.Element
}

const SectionBottomBorderTitle: FC<Props> = ({ text, subTextElement }: Props): JSX.Element => {
  return (
    <h2 className={styles.title}>
      <strong className={styles.titleText}>{text}</strong>
      {subTextElement && subTextElement}
    </h2>
  )
}

export default SectionBottomBorderTitle
